import { Injectable, EventEmitter, Output, Directive } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';

@Directive()
@Injectable({providedIn: 'root'})
export class SessionService {

  private CompanyID: number;
  private CompanyName: string;
  private IsLoggedIn: boolean;
  public ShowAnalysisLayerColumnsWarning: boolean;
  public ZendeskReturnTo: string = '';
  @Output() LoginChange: EventEmitter<boolean> = new EventEmitter();

  public constructor(private localSt: LocalStorageService ) {
    const tempCompanyID = this.localSt.retrieve('companyid');
    this.CompanyID = tempCompanyID ? tempCompanyID : 0;
    this.IsLoggedIn = this.localSt.retrieve('IsLoggedIn') === '' ? false : this.localSt.retrieve('IsLoggedIn') === 'true';
    this.ShowAnalysisLayerColumnsWarning = true;
    this.ZendeskReturnTo = this.localSt.retrieve('ZendeskReturnTo');
  }

  GetSelectedCompanyID(): number {
    return this.CompanyID;
  }

  GetSelectedCompanyName(): string {
    return this.CompanyName;
  }

  SetIsLoggedIn(loggedIn: boolean): void {
    //console.log('Set is logged in hit: ' + loggedIn);
    this.IsLoggedIn = loggedIn;
    this.localSt.store('IsLoggedIn', loggedIn ? 'true' : 'false');
    this.LoginChange.emit(loggedIn);
  }

  GetIsLoggedIn(): boolean {
    return this.IsLoggedIn;
  }

  SetUserName(username: string): void {
    this.localSt.store('username', username);
  }

  GetUserName(): string {
    return this.localSt.retrieve('username');
  }

  SetSelectedCompanyID(company: any) {
    if (company.companyID !== undefined && company.companyID !== null) {
      this.CompanyID = company.companyID;
      this.CompanyName = company.name;
      this.localSt.store('CompanyID', company.companyID);
    }
  }

  SetSelectedCompanyTheme(company: any) {
    if (company.theme !== undefined && company.theme !== null) {
      document.body.className = company.theme;
      this.localSt.store('Theme', company.theme);
    } else {
      document.body.className = 'default';
      this.localSt.store('Theme', 'default');
    } 
  }

  GetAnalysisDisplayColumns(): string[] {
    return this.localSt.retrieve('AnalysisDisplayColumns');
  }

  SetAnalysisDisplayColumns(displayColumns: string[]) {
    this.localSt.store('AnalysisDisplayColumns', displayColumns);
  }

  SetZendeskReturnTo(returnTo: string) {
    this.ZendeskReturnTo = returnTo;
    this.localSt.store('ZendeskReturnTo', returnTo);
  }

  ClearZendeskReturnTo() {
    this.ZendeskReturnTo = '';
    this.localSt.store('ZendeskReturnTo', '');
  }

  GetZendeskReturnTo() {
    return this.ZendeskReturnTo;    
  }
}

